import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Stack } from "expo-router";

export default function LocalizationDetailLayout() {
  return (
    <Stack screenOptions={{ headerShown: true, header: (props) => <ScreenHeader {...props} /> }} />
  );
}
